import { Link, useParams } from "react-router-dom";
import dataproducts from "../data";

const SingleProduct = () => {
  const { productid } = useParams();
  const product = dataproducts.find((product) => productid === product.id);
  // const {image,name} = product;
  return (
    <section className="section product">
      <h2>single product</h2>
      <img src={product.image} alt={product.name} />
      <h3>{product.name}</h3>
      <button className="btn">check details</button>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <button className="btn">Buy</button>
      <br />
      <br />
      <Link to="/products" className="btn" style={{ backgroundColor: "gray" }}>
        back to products
      </Link>
    </section>
  );
};

export default SingleProduct;
